export const isPlot = (item) => !!item && item.kind === 'plot';
export const isDevice = (item) => !!item && item.kind === 'device';
export const isStation = (item) => !!item && item.kind === 'station';
export const isStationOptionActivation = (item) => !!item && 'stationName' in item;
export const isPlotOptionActivation = (item) => !!item && 'plotName' in item;
export const isRawStationOptionActivation = (item) => !!item && 'station_name' in item;
export const isRawPlotOptionActivation = (item) => !!item && 'plot_name' in item;
